var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.user.userLevel > 80 )?_c('reportBoardView'):_c('reportAdminView')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }